export default "__VITE_ASSET__CxCkyDFq__"